// src/components/UserTypeRouter.tsx
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { UserType } from '../api/ApiTypes';
import React from "react";

interface UserTypeRouterProps {
    basePath?: string; // The base path to redirect to (e.g., "dashboard", "profile")
}

export const UserTypeRouter: React.FC<UserTypeRouterProps> = ({ basePath = "dashboard" }) => {
    const { me, isInitializing } = useAuth();

    if (isInitializing) {
        return null;
    }

    if (!me) {
        console.log("UserTypeRouter: not authenticated, redirecting to login");
        // If not authenticated, redirect to login
        return <Navigate to="/login" replace />;
    }

    // Redirect based on user type and the provided base path
    switch (me.userType) {
        case UserType.APPRAISER_ADMIN:
        case UserType.APPRAISER:
            let path = `/appraiser/${basePath}`;
            return <Navigate to={path} replace />;
        case UserType.STAFF:
            return <Navigate to={`/staff/${basePath}`} replace />;
        case UserType.SECRET:
            return <Navigate to={`/admin/${basePath}`} replace />;
        default:
            // Fallback to unauthorized page
            return <Navigate to="/unauthorized" replace />;
    }
};

export default UserTypeRouter;